import { Flex, Typography } from "antd";
import styled from "styled-components";

export const AuthWrapper = styled(Flex)`
    justify-content: center;
    align-items: center;
    padding-top: 24px;
`;

export const ForgetPasswordWrapper = styled(Flex)`
    justify-content: center;
    align-items: center;
    padding-top: 16px;
`;

export const StyledLink = styled(Typography.Text)`
    text-align: center;
    cursor: pointer;
    font-size: 14px;
`;
